export default __webpack_public_path__ + "static/media/unpublish.001bb43d.svg";